import React from 'react';

import { Text } from '~/src/dash/publicaUI';

export const MetricsSection = () => {
  return <Text>Metrics</Text>;
};
